import ApplicationController from './application_controller'

export default class TemplateSelectController extends ApplicationController {
  static targets = ['container', 'select', 'selectable']

  sync (_event) {
    const template = this.selectableTargets.find((template) => template.dataset.id === this.selectTarget.value)
    const clone = template.content.cloneNode(true)
    this.containerTarget.replaceChildren(clone)
  }
}
